<a
	class="flex no-underline rounded-xl focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus"
	data-cy="vehicle-data-pill-link"
	[href]="technicalDataUrl()"
	target="_blank"
	rel="noopener"
>
	<ui-removable-filter-button
		[hideRemoveButton]="true"
		styleClass="cursor-pointer"
		data-cy="vehicle-data-pill"
		[uiTooltip]="actuality() | vehicleDataActualityTooltip: singleVehicle()"
		[tooltipOnMobile]="true"
	>
		<div class="flex items-center gap-1">
			<div
				class="rounded-full size-2 shrink-0"
				data-cy="vehicle-data-pill-dot"
				[class]="dotColor()"
			></div>
			{{ label() }}
		</div>
	</ui-removable-filter-button>
</a>
